import { useEffect, useState } from "react";

export function useScrollSpy(
  sectionIds,
  {
    rootMargin = "-45% 0px -45% 0px", // ativa quando a seção está mais ou menos no meio
    threshold = 0.01,
  } = {}
) {
  const [activeId, setActiveId] = useState(sectionIds[0] || "");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { root: null, rootMargin, threshold }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [sectionIds, rootMargin, threshold]);

  return activeId;
}
